import { ERole } from '@dlap-ui/core';
import type { PortalConfig } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';
import { HIGH_COURT_DASHBOARD_PAGES } from './dashboard-pages.config';

export const HIGH_COURT_PORTAL_CONFIG: PortalConfig = {
  appTitle: 'ECourt',
  logoSrc: '/highcourtlogo.png',
  searchPlaceholder: 'Search applications...',
  defaultRedirect: '/overview/applications',
  rolePermissions: [
    {
      role: ERole.HIGH_COURT_ADMIN,
      permissions: [
        'overview',
        'applications',
        'fees',
        'wallet',
        'users',
        'profile',
        'memberships/members',
      ],
    },
    {
      role: ERole.CITIZEN,
      permissions: ['applications', 'fees', 'wallet', 'profile'],
    },
    {
      role: ERole.LAWYER,
      permissions: ['applications', 'applications/archived', 'applications/drafts', 'fees', 'wallet', 'profile'],
    },
    {
      role: ERole.ASSOCIATION_ADMIN,
      permissions: ['memberships/members', 'profile'],
    },
    {
      role: ERole.MEMBER_ADMIN,
      permissions: ['applications', 'users', 'profile'],
    },
  ],
  dashboardPages: HIGH_COURT_DASHBOARD_PAGES,
  newApplicationServiceKeys: ['caveat-registration', 'caveat-upliftment'],
  resolveApplicationNavigation: (service) => {
    if (service.value === 'caveat-registration' || service.value === 'caveat-upliftment') {
      return {
        commands: ['/overview/apply'],
        queryParams: { service: service.value },
        successMessage: `Starting a new ${service.name} application.`,
      };
    }

    return {
      commands: ['/overview/applications'],
      successMessage: 'New application submission for High Court is not yet available.',
    };
  },
};
